export default __webpack_public_path__ + "static/media/imgpost1.eba0a18c.jpg";